import { Box, TextField, Button, FormControl, InputLabel } from "@mui/material";

const MyButton = ({ name, onClick, isRight, marginBottom, children, disabled, style, ...props }) => {
  return (
    <Button
      variant="contained"
      fullWidth={false} // Ensure it does not stretch full width
      disabled={disabled}
      sx={{      
        height : "30px",
        textTransform: "none",
        fontFamily: window.ENV.FONT_FAMILY || 'UP-Light',
        // mt: 2,
        // mb : marginBottom ? marginBottom : 0,
        ml: isRight ? "86%" : "0%", // Align to the right
        backgroundColor: window.ENV.BUTTON.BACKGROUND_COLOR, // Set initial background color
        color: window.ENV.BUTTON.TEXT_COLOR, // Set initial text color
        borderRadius: "0 4px 4px 0", // 0 radius on the right, rounded on the left
        "&:hover": {
          backgroundColor: window.ENV.BUTTON.HOVER_BACKGROUND_COLOR, // Background color on hover
          color: window.ENV.BUTTON.HOVER_TEXT_COLOR, // Text color on hover
        },
        ...style
      }}
      onClick={onClick}
      {...props}
    >
      {children || name}
    </Button>
  );
};

export default MyButton;
